import { handleAuthResponse } from '../auth';

// with pagination
export const getFilesForGroup = groupId => {

    return fetch(`${process.env.REACT_APP_API_URL}/files/${groupId}`, {
        method: "GET",
        credentials: 'include'
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};



// Aggregates the groupId and the file categories available
export const listFilesBycategoryForGroup = (groupId, token) => {
    return fetch(`${process.env.REACT_APP_API_URL}/file/listfilesbycategory/${groupId}`, {
        method: "GET",
        credentials: 'include',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        }
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};


// with pagination
export const getFiles = page => {
    return fetch(`${process.env.REACT_APP_API_URL}/files`, {
        method: "GET",
        credentials: 'include'
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};

export const createDownloadLink = (token, fileInfo) => {

    return fetch(`${process.env.REACT_APP_API_URL}/file/downloadfile`, {
        method: "POST",
        credentials: 'include',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
        body: JSON.stringify(fileInfo)
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};

export const updateFile = (fileId, userId, fileData) => {
    return fetch(`${process.env.REACT_APP_API_URL}/file/${fileId}/${userId}`, {
        method: "PUT",
        credentials: 'include',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify(fileData)
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};

export const deleteFile = (fileId, userId) => {
    return fetch(`${process.env.REACT_APP_API_URL}/file/${fileId}/${userId}`, {
        method: "DELETE",
        credentials: 'include',
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        }
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};

export const createNewFile = (token, userId, fileInfo) => {
    // /file/create/:userId
    return fetch(`${process.env.REACT_APP_API_URL}/file/create/${userId}`, {
        method: "POST",
        credentials: 'include',
        headers: {
            Accept: 'application/json',
        },
        body: fileInfo
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || "Network error" }; });
};

